import API from "../api";
import { apiCallbackTreatment} from "../auxiliary/generalFunctions";

var api = new API();

export default class IntegrationsController
{
    async get()
    {
        const response = await api.integrations().get();
        return apiCallbackTreatment(response);
    }

    async getPixels()
    {
        const response = await api.integrations().getPixels();
        return apiCallbackTreatment(response);
    }

    async getTargets()
    {
        const response = await api.integrations().getTargets();
        return apiCallbackTreatment(response);
    }

    async post(data)
    {
        const response = await api.integrations().post(data);
        return apiCallbackTreatment(response);
    }

    async createPixel(data)
    {
        const response = await api.integrations().createPixel(data);
        return apiCallbackTreatment(response);
    }

    async resendEventPurchase(data)
    {
        const response = await api.integrations().resendEventPurchase(data);
        return apiCallbackTreatment(response);
    }

    async updatePixel(data)
    {
        const response = await api.integrations().updatePixel(data);
        return apiCallbackTreatment(response);
    }

    async updateTarget(data)
    {
        const response = await api.integrations().updateTarget(data);
        return apiCallbackTreatment(response);
    }

    async saveFormFromPage(data)
    {
        const response = await api.integrations().saveFormFromPage(data);
        return apiCallbackTreatment(response);
    }
}